import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { apolloFactory } from '@insolution/graphql-data-access';
import { LazyTranslateLoader } from '@insolution/language-data-access';
import { environment } from '../environments/environment';
import { RumProvider } from '@insolution/audit-data-access';
import { BrandingService } from '@insolution/branding-util';
import { AppVersionService } from '@insolution/core-data-access';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return apolloFactory(httpLink, environment.graphqlEndpoint, environment.region);
    }),
    RumProvider.provide({
      appId: environment.rumConfiguration.appMonitorId,
      identityPoolId: environment.rumConfiguration.identityPoolId,
      region: environment.rumConfiguration.region,
      appVersion: environment.rumConfiguration.appVersion,
      sessionSampleRate: environment.rumConfiguration.sampleRate,
    }),
    provideTranslateService({
      loader: provideTranslateLoader(LazyTranslateLoader),
      fallbackLang: 'en-US',
      lang: 'en-US',
    }),
    provideAppInitializer(() => {
      inject(BrandingService).applyBranding();
    }),
    provideAppInitializer(() => {
      const appVersionService = inject(AppVersionService);
      return appVersionService.startVersionCheck();
    }),
  ],
};
